export default __webpack_public_path__ + "static/media/Sui.5aea3b15.PNG";